module.exports = __webpack_public_path__ + "img/result.af4a689f.png";